import { render, staticRenderFns } from "./ClinicShowXmlRecipe.vue?vue&type=template&id=063f2647"
import script from "./ClinicShowXmlRecipe.vue?vue&type=script&lang=js"
export * from "./ClinicShowXmlRecipe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports